import type MarkdownIt from 'markdown-it';
import type StateCore from 'markdown-it/lib/rules_core/state_core.mjs';
import type Token from 'markdown-it/lib/token.mjs';

const EXPAND_REGEX = /\[\^(expand)\^\]/;

const expandable = (state: StateCore) => {
	const tokens: Token[] = [];
	let expandCounter = 0;

	for (const token of state.tokens) {
		const tokenChildren: Array<Token | null> = [];

		if (token.type !== 'inline' || token.children?.length === 0) {
			tokens.push(token);
			continue;
		}

		if (token.children) {
			token.children.forEach((childToken) => {
				if (childToken.type === 'text' && EXPAND_REGEX.test(childToken.content)) {
					const parts = childToken.content.split(EXPAND_REGEX);
					parts.forEach((part, index) => {
						if (index % 2 === 0) {
							const textToken = new state.Token('text', '', 0);
							textToken.content = part;
							textToken.level = childToken.level;
							tokenChildren.push(textToken);
						} else {
							const expandToken = new state.Token('status', '', 0);
							expandToken.content = '';
							expandToken.block = false;
							expandToken.level = childToken.level;
							expandToken.attrs = [
								['localId', 'expandable-' + expandCounter],
								['text', 'expandable-' + expandCounter],
								['color', 'blue'],
							];
							tokenChildren.push(expandToken);
							expandCounter++;
						}
					});
					return;
				}

				tokenChildren.push(childToken);
			});
		}

		const filteredTokenChildren = tokenChildren.filter(
			(childToken) => childToken !== null,
		) as Token[];
		token.children = filteredTokenChildren;
		tokens.push(token);
	}

	state.tokens = tokens;
	return;
};

const mdPluginExpandable = (md: MarkdownIt) => {
	md.core.ruler.push('expandable', expandable);
};

export default mdPluginExpandable;
